import { AnyAction } from '@reduxjs/toolkit'

import {
  ADD_TOOLBAR_INSTANCE_SUCCESS,
  CLEAR_CURRENT_TOOLBAR,
  DELETE_TOOLBAR_INSTANCE_SUCCESS,
  FETCH_TOOLBAR_INSTANCES_SUCCESS,
  SET_CURRENT_TOOLBAR,
  UPDATE_TOOLBAR_INSTANCE_SUCCESS
} from './actionTypes'

export type OrganizationToolbarPageState = {
  toolbars: any[]
}

export const initialState: OrganizationToolbarPageState = { toolbars: [] }

export default (state = initialState, action: AnyAction): OrganizationToolbarPageState => {
  switch (action.type) {
    case FETCH_TOOLBAR_INSTANCES_SUCCESS: {
      return {
        ...state,
        toolbars: action.response.map((toolbar: any) => ({ ...toolbar, currentToolbar: false }))
      }
    }
    case DELETE_TOOLBAR_INSTANCE_SUCCESS: {
      return {
        ...state,
        toolbars: state.toolbars.filter(toolbar => toolbar.id !== action.toolbarId)
      }
    }
    case ADD_TOOLBAR_INSTANCE_SUCCESS: {
      return {
        ...state,
        toolbars: [
          ...state.toolbars.map(toolbar => ({ ...toolbar, currentToolbar: false })),
          { ...action.response, name: action.name, description: action.description, currentToolbar: true }
        ]
      }
    }
    case UPDATE_TOOLBAR_INSTANCE_SUCCESS: {
      return {
        ...state,
        toolbars: state.toolbars.map(toolbar => {
          if (toolbar.id !== action.response.id) {
            return toolbar
          }
          return {
            ...toolbar,
            ...action.response,
            currentToolbar: false
          }
        })
      }
    }
    case SET_CURRENT_TOOLBAR: {
      return {
        ...state,
        toolbars: state.toolbars.map(toolbar => {
          if (toolbar.id !== action.toolbar.id) {
            return { ...toolbar, currentToolbar: false }
          }
          return {
            ...toolbar,
            currentToolbar: true
          }
        })
      }
    }
    case CLEAR_CURRENT_TOOLBAR: {
      return {
        ...state,
        toolbars: state.toolbars.map(toolbar => ({ ...toolbar, currentToolbar: false }))
      }
    }
    default: {
      return state
    }
  }
}
